module.exports = __webpack_public_path__ + "img/icon_classify09.50da0922.png";